import { Server, identityClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getEventKeyMappingsDatatable: ApiMethod<
  Server.EventKeyMappingsDatatableInput,
  Server.TableOfEventKeyMappingsColumns
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_EventKeyMapping_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_EventKeyMapping_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getEventKeyMappingById: ApiMethod<
  number,
  Server.EventKeyMappingDashboardOutput
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_EventKeyMapping_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_EventKeyMapping_byId_get_V1(undefined, id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editEventKeyMapping: ApiMethod<
  Server.UpdateEventKeyMappingValueInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_EventKeyMapping_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_EventKeyMapping_eventValue_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const changeEventKeyMappingPublishingState: ApiMethod<
  Server.UpdateEventKeyMappingPublishingStateInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_EventKeyMapping_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_EventKeyMapping_publishingState_put_V1(
      data
    );

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
